import React from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
import { useStateContext } from "../contexts/ContextProvider";
import NavButton from "./NavButton";

const HamburgerButton = () => {
  const { activeMenu, setActiveMenu, setShowRoomSearch } = useStateContext();

  const handleActiveMenu = () => {
    // close search if sidebar is clicked
    setShowRoomSearch(false);
    setActiveMenu(!activeMenu);
  };

  return (
    <div>
      <NavButton
        title="Sidebar"
        customFunc={handleActiveMenu}
        color="black"
        // dotColor="red"
        icon={
          activeMenu ? (
            <div className="text-snappily-orange bg-gray-200 rounded-full p-1">
              <IoCloseSharp
                className="text-4xl rounded-full p-1 z-30"
                onClick={handleActiveMenu}
              />
            </div>
          ) : (
            <div
              className="text-snappily-orange bg-white hover:bg-snappily-orange 
            hover:text-white rounded-full p-1"
            >
              <AiOutlineMenu className="text-4xl rounded-full p-1" />
            </div>
          )
        }
      />
    </div>
  );
};

export default HamburgerButton;
